const ChangeGuide = function() {

    const changeLayout = (el) => {

        let selected = el.attr('data-guide');
        
        $('.change-guide').removeClass('actived');
        $(el).addClass('actived');
        
        if(selected == 0) {
            $("#list-products")
                .find('.el-product').removeClass('col-md-6')
                .end().find('.wrap-desc-bt').addClass('title-exp');
        } else {
            $("#list-products")
                .find('.el-product').addClass('col-md-6')
                .end().find('.wrap-desc-bt').removeClass('title-exp');
        }
    }

    return {
        init : () => {

            $(".change-guide").on('click' , function(e){
                e.preventDefault();
                changeLayout($(this));
            })

        }
    }

}();

module.exports = ChangeGuide;